import { createStore } from "vuex";
/*
Notes:
P_ID = page id
AP_ID = active page id

C_ID = component id
AC_ID = active component id
AC_TYPE = active component type
*/
export default createStore({
  state: {
    general: {
      active_page: 0,
    },
    pages: [
      {
        P_ID: 0,
        name: "Untitled",
        components: {
          AC_TYPE: "",
          AC_ID: null,
          header: [],
          home: [],
          sections: [],
          footer: [],
        },
      },
    ],
  },
  getters: {
    get_options: (state) => {
      let AP_ID = state.general.active_page;
      let type = state.pages[AP_ID].components.AC_TYPE;
      let code = state.pages[AP_ID].components.AC_ID;
      if (type != "" && code != null) {
        let options = state.pages[AP_ID].components[type][code].data;
        return options;
      }
      return null;
    },
    get_active_component_type: (state) => {
      let AP_ID = state.general.active_page;
      return state.pages[AP_ID].components.AC_TYPE;
    },
    get_active_component_code: (state) => {
      let AP_ID = state.general.active_page;
      return state.pages[AP_ID].components.AC_ID;
    },
    get_page_name: (state) => {
      let AP_ID = state.general.active_page;
      return state.pages[AP_ID].name;
    },
    check_if_empty: (state) => {
      let AP_ID = state.general.active_page;
      if (
        state.pages[AP_ID].components.header.length == 0 &&
        state.pages[AP_ID].components.home.length == 0 &&
        state.pages[AP_ID].components.sections.length == 0 &&
        state.pages[AP_ID].components.footer.length == 0
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  mutations: {
    add_page(state) {
      state.pages.push({
        P_ID: state.pages.length,
        name: "Untitled",
        components: {
          AC_TYPE: "",
          AC_ID: null,
          header: [],
          home: [],
          sections: [],
          footer: [],
        },
      });
      state.general.active_page = state.pages.length - 1;
    },
    make_page_active(state, id) {
      state.general.active_page = id;
    },
    add_component(state, info) {
      let AP_ID = state.general.active_page;
      let type = info.type;
      let type_length = state.pages[AP_ID].components[type].length;
      if (
        (type == "header" && type_length < 1) ||
        (type == "home" && type_length < 1) ||
        (type == "sections" && type_length < 15) ||
        (type == "footer" && type_length < 1)
      ) {
        state.pages[AP_ID].components[type].push({
          C_ID: state.pages[AP_ID].components[type].length,
          name: info.c_name,
          data: info.c_data,
        });
      }
    },
    make_component_active(state, info) {
      let AP_ID = state.general.active_page;
      state.pages[AP_ID].components.AC_TYPE = info.type;
      state.pages[AP_ID].components.AC_ID = info.uid;
    },
    update_page_name(state, name) {
      let AP_ID = state.general.active_page;
      state.pages[AP_ID].name = name;
    },
    check_page_name(state) {
      let AP_ID = state.general.active_page;
      if (state.pages[AP_ID].name == "") {
        state.pages[AP_ID].name = "Untitled";
      }
    },
  },
});
